var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _circle173, _circle174, _circle175, _circle176, _circle177, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradient(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1728,
    height: 1117,
    viewBox: "0 0 1728 1117",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 697.925,
    cy: 951.488,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 357.369,
    cy: 163.285,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1552.7,
    cy: 905.134,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 870.629,
    cy: 996.668,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1533.45,
    cy: 742.658,
    r: 1,
    fill: "#D9D9D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 954.445,
    cy: 267.678,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.39,
    cy: 803.948,
    r: 1,
    fill: "#D9D9D9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.852,
    cy: 982.753,
    r: 1,
    fill: "#D9D9D9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1481.1,
    cy: 646.467,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 870.361,
    cy: 825.118,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 888.849,
    cy: 236.605,
    r: 1,
    fill: "#D9D9D9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 750.462,
    cy: 324.374,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1367.38,
    cy: 1039.75,
    r: 1,
    fill: "#808080"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 332.763,
    cy: 372.031,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1475.88,
    cy: 120.651,
    r: 1,
    fill: "#D9D9D9"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 1208.44,
    cy: 125.787,
    r: 1,
    fill: "#D9D9D9"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 1632.48,
    cy: 529.214,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 941.275,
    cy: 531.367,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 1096.69,
    cy: 360.902,
    r: 1,
    fill: "#D9D9D9"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 969.444,
    cy: 858.489,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.24,
    cy: 49.7039,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 1608.39,
    cy: 1023.83,
    r: 1,
    fill: "#D9D9D9"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 566.903,
    cy: 213.465,
    r: 1,
    fill: "#D9D9D9"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 1557.8,
    cy: 514.525,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 1255.48,
    cy: 717.034,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.466,
    cy: 980.024,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 933.479,
    cy: 589.939,
    r: 1,
    fill: "#808080"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 1418.85,
    cy: 408.131,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.008,
    cy: 456.215,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.379,
    cy: 793.082,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 1355.31,
    cy: 975.9,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 1595.85,
    cy: 16.6943,
    r: 1,
    fill: "#808080"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 1202,
    cy: 619.861,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 1134.72,
    cy: 547.478,
    r: 1,
    fill: "#D9D9D9"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 1099.53,
    cy: 736.273,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.964,
    cy: 32.2009,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 1455.06,
    cy: 897.117,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.695,
    cy: 752.879,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 1021.28,
    cy: 592.59,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 1524.07,
    cy: 217.539,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 1533.91,
    cy: 792.243,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.784,
    cy: 422.578,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.906,
    cy: 716.236,
    r: 1,
    fill: "#D9D9D9"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 501.77,
    cy: 547.15,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.184,
    cy: 993.232,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 962.755,
    cy: 52.6799,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 845.417,
    cy: 335.879,
    r: 1,
    fill: "#D9D9D9"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 1224.84,
    cy: 545.829,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.255,
    cy: 1016.51,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.913,
    cy: 272.439,
    r: 1,
    fill: "#D9D9D9"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 1504.48,
    cy: 399.203,
    r: 1,
    fill: "#808080"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 1005.36,
    cy: 6.30957,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 628.406,
    cy: 691.03,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 1581.16,
    cy: 189.971,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 1433.52,
    cy: 202.71,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 1104.56,
    cy: 671.837,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.517,
    cy: 527.222,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 518.113,
    cy: 36.334,
    r: 1,
    fill: "#808080"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 897.228,
    cy: 477.465,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 455.047,
    cy: 168.021,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 1328.86,
    cy: 31.7246,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 741.19,
    cy: 782.635,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.495,
    cy: 247.777,
    r: 1,
    fill: "#808080"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.354,
    cy: 761.953,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.618,
    cy: 801.016,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 1330.53,
    cy: 199.907,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 1047.07,
    cy: 776.194,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 1676.48,
    cy: 961.314,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 1366.36,
    cy: 107.642,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 1360.08,
    cy: 751.303,
    r: 1,
    fill: "#D9D9D9"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.631,
    cy: 149.732,
    r: 1,
    fill: "#D9D9D9"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 1718.66,
    cy: 193.512,
    r: 1,
    fill: "#D9D9D9"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 876.38,
    cy: 397.685,
    r: 1,
    fill: "#D9D9D9"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 1341.75,
    cy: 291.558,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 1260.32,
    cy: 732.76,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 1602.94,
    cy: 10.4114,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 831.647,
    cy: 234.566,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 1371.15,
    cy: 1029.36,
    r: 1,
    fill: "#D9D9D9"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 1554.28,
    cy: 628.872,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 1622.45,
    cy: 536.417,
    r: 1,
    fill: "#D9D9D9"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.438,
    cy: 487.256,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 1698.61,
    cy: 1089.35,
    r: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 1359.11,
    cy: 298.316,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 1304.23,
    cy: 280.2,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 644.083,
    cy: 295.325,
    r: 2.5,
    fill: "#D9D9D9"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 1645.35,
    cy: 637.875,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 1583.75,
    cy: 927.794,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.331,
    cy: 1035.53,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 1167.16,
    cy: 74.4609,
    r: 2.5,
    fill: "#D9D9D9"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 814.936,
    cy: 799.613,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 694.029,
    cy: 131.215,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.848,
    cy: 436.209,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.362,
    cy: 132.409,
    r: 2.5,
    fill: "#D9D9D9"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.137,
    cy: 245.675,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 1324.83,
    cy: 778.698,
    r: 2.5,
    fill: "#D9D9D9"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.157,
    cy: 467.819,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 454.023,
    cy: 660.142,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 1373.61,
    cy: 120.573,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.0659,
    cy: 136.95,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 981.116,
    cy: 708.061,
    r: 2.5,
    fill: "#D9D9D9"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 822.636,
    cy: 1113.13,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 1585.15,
    cy: 1035.55,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 1245.12,
    cy: 717.313,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 1605.57,
    cy: 326.804,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 1208.82,
    cy: 119.092,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.123,
    cy: 287.012,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.57837,
    cy: 116.473,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.53418,
    cy: 896.691,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 687.522,
    cy: 73.9121,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 1416.55,
    cy: 152.674,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 1528.63,
    cy: 698.258,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 611.466,
    cy: 1091.15,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.878,
    cy: 160.461,
    r: 2.5,
    fill: "#D9D9D9"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.521,
    cy: 575.033,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 540.884,
    cy: 782.259,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 1619.09,
    cy: 159.791,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 1683.32,
    cy: 450.64,
    r: 2.5,
    fill: "#D9D9D9"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 509.984,
    cy: 483.552,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.9,
    cy: 430.794,
    r: 2.5,
    fill: "#D9D9D9"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 448.832,
    cy: 497.06,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 1721.41,
    cy: 819.217,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 483.704,
    cy: 502.879,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 801.951,
    cy: 967.524,
    r: 2.5,
    fill: "#D9D9D9"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.84,
    cy: 232.032,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 1598.68,
    cy: 221.158,
    r: 2.5,
    fill: "#808080"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 1236.74,
    cy: 166.192,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 1516.23,
    cy: 137.235,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.692,
    cy: 110.643,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.1182,
    cy: 935.331,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 1673.78,
    cy: 1007.46,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 805.952,
    cy: 794.324,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 972.533,
    cy: 129.84,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 1153.56,
    cy: 523.638,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369.48,
    cy: 207.716,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 1460.93,
    cy: 1010.13,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.51,
    cy: 1085.37,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.762,
    cy: 569.624,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 718.904,
    cy: 159.926,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.282,
    cy: 1099.04,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.387,
    cy: 301.531,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 1057.86,
    cy: 1031.79,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 1581.94,
    cy: 1093.68,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 973.15,
    cy: 763.593,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.11,
    cy: 388.253,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 1636.79,
    cy: 489.193,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.2942,
    cy: 599.712,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.2185,
    cy: 957.188,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 1213.52,
    cy: 689.923,
    r: 2.5,
    fill: "#D9D9D9"
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.125,
    cy: 26.9556,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229.78,
    cy: 414.191,
    r: 2.5,
    fill: "#D9D9D9"
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 573.166,
    cy: 839.371,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 902.871,
    cy: 1066.24,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 1361,
    cy: 1109.41,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 1555.45,
    cy: 398.704,
    r: 2.5,
    fill: "#D9D9D9"
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.099,
    cy: 658.979,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 1631.93,
    cy: 1027.25,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 671.805,
    cy: 712.204,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 761.927,
    cy: 14.0408,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 1429,
    cy: 239.194,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.979,
    cy: 771.806,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 372.396,
    cy: 880.418,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.822,
    cy: 175.543,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.152,
    cy: 401.329,
    r: 2.5,
    fill: "#D9D9D9"
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 750.122,
    cy: 1041.01,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    cx: 1440.52,
    cy: 746.56,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    cx: 1135.85,
    cy: 706.534,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5205,
    cy: 759.885,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    cx: 1217.87,
    cy: 372.093,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    cx: 1671.65,
    cy: 376.086,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    cx: 1298.24,
    cy: 84.9426,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.219,
    cy: 855.726,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    cx: 748.199,
    cy: 48.9011,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.479,
    cy: 1025.93,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    cx: 1016.35,
    cy: 767.533,
    r: 2.5,
    fill: "#808080"
  })), _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    cx: 1575.09,
    cy: 642.702,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    cx: 1661.96,
    cy: 857.327,
    r: 2.5,
    fill: "#D9D9D9"
  })), _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.962,
    cy: 219.708,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.781,
    cy: 973.836,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _circle177 || (_circle177 = /*#__PURE__*/React.createElement("circle", {
    cx: 817.906,
    cy: 551.523,
    r: 2.5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M799.004 759.531L799.534 761.5L801.504 762.031L799.534 762.561L799.004 764.531L798.474 762.561L796.504 762.031L798.474 761.5L799.004 759.531Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M896.524 238.765L897.055 240.735L899.024 241.265L897.055 241.796L896.524 243.765L895.994 241.796L894.024 241.265L895.994 240.735L896.524 238.765Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M864.507 363.437L865.037 365.407L867.007 365.937L865.037 366.467L864.507 368.437L863.977 366.467L862.007 365.937L863.977 365.407L864.507 363.437Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1358.98 261.806L1359.51 263.776L1361.48 264.306L1359.51 264.836L1358.98 266.806L1358.45 264.836L1356.48 264.306L1358.45 263.776L1358.98 261.806Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.53 1069.23L1297.06 1071.19L1299.03 1071.73L1297.06 1072.26L1296.53 1074.23L1296 1072.26L1294.03 1071.73L1296 1071.19L1296.53 1069.23Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1300.35 809.247L1300.88 811.217L1302.85 811.747L1300.88 812.278L1300.35 814.247L1299.82 812.278L1297.85 811.747L1299.82 811.217L1300.35 809.247Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M253.787 59.594L254.317 61.5637L256.287 62.094L254.317 62.6243L253.787 64.594L253.256 62.6243L251.287 62.094L253.256 61.5637L253.787 59.594Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1135.55 111.831L1136.08 113.801L1138.05 114.331L1136.08 114.862L1135.55 116.831L1135.02 114.862L1133.05 114.331L1135.02 113.801L1135.55 111.831Z",
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.31 1094.85L1074.84 1096.81L1076.81 1097.35L1074.84 1097.88L1074.31 1099.85L1073.78 1097.88L1071.81 1097.35L1073.78 1096.81L1074.31 1094.85Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1251.54 668.438L1252.07 670.408L1254.04 670.938L1252.07 671.468L1251.54 673.438L1251.01 671.468L1249.04 670.938L1251.01 670.408L1251.54 668.438Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M613.45 944.515L613.981 946.484L615.95 947.015L613.981 947.545L613.45 949.515L612.92 947.545L610.95 947.015L612.92 946.484L613.45 944.515Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1531.84 1020.74L1532.37 1022.71L1534.34 1023.24L1532.37 1023.77L1531.84 1025.74L1531.31 1023.77L1529.34 1023.24L1531.31 1022.71L1531.84 1020.74Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M507.633 227.669L508.163 229.639L510.133 230.169L508.163 230.7L507.633 232.669L507.102 230.7L505.133 230.169L507.102 229.639L507.633 227.669Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.11 246.445L1099.64 248.415L1101.61 248.945L1099.64 249.476L1099.11 251.445L1098.58 249.476L1096.61 248.945L1098.58 248.415L1099.11 246.445Z",
    fill: "#D9D9D9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M949.983 1102.53L950.513 1104.5L952.483 1105.03L950.513 1105.56L949.983 1107.53L949.453 1105.56L947.483 1105.03L949.453 1104.5L949.983 1102.53Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1602.92 399.816L1603.45 401.785L1605.42 402.316L1603.45 402.846L1602.92 404.816L1602.38 402.846L1600.42 402.316L1602.38 401.785L1602.92 399.816Z",
    fill: "#D9D9D9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1430.4 267.555L1430.93 269.525L1432.9 270.055L1430.93 270.586L1430.4 272.555L1429.87 270.586L1427.9 270.055L1429.87 269.525L1430.4 267.555Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M846.02 245.102L846.55 247.072L848.52 247.602L846.55 248.132L846.02 250.102L845.49 248.132L843.52 247.602L845.49 247.072L846.02 245.102Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M743.536 112.054L744.067 114.024L746.036 114.554L744.067 115.085L743.536 117.054L743.006 115.085L741.036 114.554L743.006 114.024L743.536 112.054Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7627 635.961L29.293 637.931L31.2627 638.461L29.293 638.992L28.7627 640.961L28.2324 638.992L26.2627 638.461L28.2324 637.931L28.7627 635.961Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M614.107 1003.87L614.637 1005.84L616.607 1006.37L614.637 1006.9L614.107 1008.87L613.577 1006.9L611.607 1006.37L613.577 1005.84L614.107 1003.87Z",
    fill: "#D9D9D9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M723.271 9.29126L723.801 11.2609L725.771 11.7913L723.801 12.3216L723.271 14.2913L722.74 12.3216L720.771 11.7913L722.74 11.2609L723.271 9.29126Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1429.29 1069.33L1429.82 1071.3L1431.79 1071.83L1429.82 1072.36L1429.29 1074.33L1428.76 1072.36L1426.79 1071.83L1428.76 1071.3L1429.29 1069.33Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1271.7 1070.25L1272.23 1072.22L1274.2 1072.75L1272.23 1073.28L1271.7 1075.25L1271.17 1073.28L1269.2 1072.75L1271.17 1072.22L1271.7 1070.25Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M408.374 91.0828L408.904 93.0524L410.874 93.5828L408.904 94.1131L408.374 96.0828L407.844 94.1131L405.874 93.5828L407.844 93.0524L408.374 91.0828Z",
    fill: "#D9D9D9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M974.581 580.751L975.111 582.721L977.081 583.251L975.111 583.781L974.581 585.751L974.05 583.781L972.081 583.251L974.05 582.721L974.581 580.751Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.25 881.977L1184.78 883.947L1186.75 884.477L1184.78 885.008L1184.25 886.977L1183.72 885.008L1181.75 884.477L1183.72 883.947L1184.25 881.977Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M343.758 94.7405L344.288 96.7101L346.258 97.2405L344.288 97.7708L343.758 99.7405L343.227 97.7708L341.258 97.2405L343.227 96.7101L343.758 94.7405Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M743.664 1031.04L744.195 1033.01L746.164 1033.54L744.195 1034.07L743.664 1036.04L743.134 1034.07L741.164 1033.54L743.134 1033.01L743.664 1031.04Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M360 649.358L360.53 651.328L362.5 651.858L360.53 652.388L360 654.358L359.47 652.388L357.5 651.858L359.47 651.328L360 649.358Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M667.077 224.707L667.607 226.676L669.577 227.207L667.607 227.737L667.077 229.707L666.546 227.737L664.577 227.207L666.546 226.676L667.077 224.707Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M906.067 195.29L906.598 197.26L908.567 197.79L906.598 198.32L906.067 200.29L905.537 198.32L903.567 197.79L905.537 197.26L906.067 195.29Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M552.938 111.177L553.469 113.147L555.438 113.677L553.469 114.208L552.938 116.177L552.408 114.208L550.438 113.677L552.408 113.147L552.938 111.177Z",
    fill: "#D9D9D9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1187.38 391.649L1187.91 393.618L1189.88 394.149L1187.91 394.679L1187.38 396.649L1186.85 394.679L1184.88 394.149L1186.85 393.618L1187.38 391.649Z",
    fill: "#D9D9D9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1265.86 1035.65L1266.39 1037.62L1268.36 1038.15L1266.39 1038.68L1265.86 1040.65L1265.33 1038.68L1263.36 1038.15L1265.33 1037.62L1265.86 1035.65Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M548.364 387.582L548.894 389.551L550.864 390.082L548.894 390.612L548.364 392.582L547.833 390.612L545.864 390.082L547.833 389.551L548.364 387.582Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.92 681.154L1262.45 683.124L1264.42 683.654L1262.45 684.184L1261.92 686.154L1261.39 684.184L1259.42 683.654L1261.39 683.124L1261.92 681.154Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M222.735 768.113L223.265 770.082L225.235 770.613L223.265 771.143L222.735 773.113L222.204 771.143L220.235 770.613L222.204 770.082L222.735 768.113Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M253.069 107.665L253.599 109.635L255.569 110.165L253.599 110.695L253.069 112.665L252.539 110.695L250.569 110.165L252.539 109.635L253.069 107.665Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M314.77 1021.36L315.3 1023.33L317.27 1023.86L315.3 1024.39L314.77 1026.36L314.24 1024.39L312.27 1023.86L314.24 1023.33L314.77 1021.36Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M168.61 990.429L169.141 992.399L171.11 992.929L169.141 993.46L168.61 995.429L168.08 993.46L166.11 992.929L168.08 992.399L168.61 990.429Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M553.282 746.364L553.812 748.334L555.782 748.864L553.812 749.395L553.282 751.364L552.751 749.395L550.782 748.864L552.751 748.334L553.282 746.364Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M296.313 436.456L296.844 438.425L298.813 438.956L296.844 439.486L296.313 441.456L295.783 439.486L293.813 438.956L295.783 438.425L296.313 436.456Z",
    fill: "#D9D9D9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1460.58 609.1L1461.11 611.07L1463.08 611.6L1461.11 612.131L1460.58 614.1L1460.05 612.131L1458.08 611.6L1460.05 611.07L1460.58 609.1Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M310.649 744.014L311.18 745.983L313.149 746.514L311.18 747.044L310.649 749.014L310.119 747.044L308.149 746.514L310.119 745.983L310.649 744.014Z",
    fill: "#808080"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M574.459 469.497L574.99 471.466L576.959 471.997L574.99 472.527L574.459 474.497L573.929 472.527L571.959 471.997L573.929 471.466L574.459 469.497Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1615.42 382.384L1615.95 384.354L1617.92 384.884L1615.95 385.414L1615.42 387.384L1614.89 385.414L1612.92 384.884L1614.89 384.354L1615.42 382.384Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.84 378.572L1115.37 380.542L1117.34 381.072L1115.37 381.603L1114.84 383.572L1114.31 381.603L1112.34 381.072L1114.31 380.542L1114.84 378.572Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0437 466.36L53.574 468.33L55.5437 468.86L53.574 469.391L53.0437 471.36L52.5134 469.391L50.5437 468.86L52.5134 468.33L53.0437 466.36Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1401.52 5.86328L1402.05 7.83295L1404.02 8.36328L1402.05 8.89361L1401.52 10.8633L1400.99 8.89361L1399.02 8.36328L1400.99 7.83295L1401.52 5.86328Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M995.1 276.298L995.63 278.268L997.6 278.798L995.63 279.328L995.1 281.298L994.57 279.328L992.6 278.798L994.57 278.268L995.1 276.298Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M433.724 761.822L434.254 763.791L436.224 764.322L434.254 764.852L433.724 766.822L433.194 764.852L431.224 764.322L433.194 763.791L433.724 761.822Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M384.833 172.626L385.364 174.596L387.333 175.126L385.364 175.657L384.833 177.626L384.303 175.657L382.333 175.126L384.303 174.596L384.833 172.626Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M893.044 835.008L893.574 836.977L895.544 837.508L893.574 838.038L893.044 840.008L892.513 838.038L890.544 837.508L892.513 836.977L893.044 835.008Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1268.65 56.0598L1269.18 58.0295L1271.15 58.5598L1269.18 59.0901L1268.65 61.0598L1268.12 59.0901L1266.15 58.5598L1268.12 58.0295L1268.65 56.0598Z",
    fill: "#D9D9D9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1490.6 867.743L1491.13 869.713L1493.1 870.243L1491.13 870.774L1490.6 872.743L1490.07 870.774L1488.1 870.243L1490.07 869.713L1490.6 867.743Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M498.87 1094.22L499.4 1096.19L501.37 1096.72L499.4 1097.25L498.87 1099.22L498.34 1097.25L496.37 1096.72L498.34 1096.19L498.87 1094.22Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M799.755 450.887L800.285 452.857L802.255 453.387L800.285 453.918L799.755 455.887L799.225 453.918L797.255 453.387L799.225 452.857L799.755 450.887Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M307.59 428.053L308.121 430.022L310.09 430.553L308.121 431.083L307.59 433.053L307.06 431.083L305.09 430.553L307.06 430.022L307.59 428.053Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9521 668.316L89.4825 670.286L91.4521 670.816L89.4825 671.347L88.9521 673.316L88.4218 671.347L86.4521 670.816L88.4218 670.286L88.9521 668.316Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M610.142 762.732L610.672 764.702L612.642 765.232L610.672 765.762L610.142 767.732L609.612 765.762L607.642 765.232L609.612 764.702L610.142 762.732Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M217.716 32.8147L218.246 34.7844L220.216 35.3147L218.246 35.845L217.716 37.8147L217.185 35.845L215.216 35.3147L217.185 34.7844L217.716 32.8147Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M230.263 918.553L230.793 920.523L232.763 921.053L230.793 921.584L230.263 923.553L229.733 921.584L227.763 921.053L229.733 920.523L230.263 918.553Z",
    fill: "#D9D9D9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M184.801 753.114L185.331 755.084L187.301 755.614L185.331 756.144L184.801 758.114L184.27 756.144L182.301 755.614L184.27 755.084L184.801 753.114Z",
    fill: "#D9D9D9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M147.246 889.441L147.776 891.411L149.746 891.941L147.776 892.471L147.246 894.441L146.716 892.471L144.746 891.941L146.716 891.411L147.246 889.441Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1507.58 65.2429L1508.11 67.2126L1510.08 67.7429L1508.11 68.2733L1507.58 70.2429L1507.05 68.2733L1505.08 67.7429L1507.05 67.2126L1507.58 65.2429Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M696.222 374.209L696.752 376.179L698.722 376.709L696.752 377.24L696.222 379.209L695.692 377.24L693.722 376.709L695.692 376.179L696.222 374.209Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M822.468 538.878L822.998 540.847L824.968 541.378L822.998 541.908L822.468 543.878L821.937 541.908L819.968 541.378L821.937 540.847L822.468 538.878Z",
    fill: "#808080"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M492.787 262.268L493.317 264.237L495.287 264.768L493.317 265.298L492.787 267.268L492.257 265.298L490.287 264.768L492.257 264.237L492.787 262.268Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M75.248 381.768L75.7784 383.737L77.748 384.268L75.7784 384.798L75.248 386.768L74.7177 384.798L72.748 384.268L74.7177 383.737L75.248 381.768Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1436.34 885.05L1436.87 887.02L1438.84 887.55L1436.87 888.081L1436.34 890.05L1435.81 888.081L1433.84 887.55L1435.81 887.02L1436.34 885.05Z",
    fill: "#808080"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M803.497 719.631L804.027 721.601L805.997 722.131L804.027 722.662L803.497 724.631L802.966 722.662L800.997 722.131L802.966 721.601L803.497 719.631Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.08 409.046L1172.61 411.015L1174.58 411.546L1172.61 412.076L1172.08 414.046L1171.55 412.076L1169.58 411.546L1171.55 411.015L1172.08 409.046Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1691.42 633.464L1691.95 635.434L1693.92 635.964L1691.95 636.494L1691.42 638.464L1690.89 636.494L1688.92 635.964L1690.89 635.434L1691.42 633.464Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.72 541.158L1387.25 543.127L1389.22 543.658L1387.25 544.188L1386.72 546.158L1386.19 544.188L1384.22 543.658L1386.19 543.127L1386.72 541.158Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M461.382 458.159L461.912 460.129L463.882 460.659L461.912 461.19L461.382 463.159L460.852 461.19L458.882 460.659L460.852 460.129L461.382 458.159Z",
    fill: "#D9D9D9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M824.298 286.802L824.829 288.772L826.798 289.302L824.829 289.833L824.298 291.802L823.768 289.833L821.798 289.302L823.768 288.772L824.298 286.802Z",
    fill: "#D9D9D9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1051.97 454.588L1052.5 456.557L1054.47 457.088L1052.5 457.618L1051.97 459.588L1051.44 457.618L1049.47 457.088L1051.44 456.557L1051.97 454.588Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M746.38 519.878L746.91 521.847L748.88 522.378L746.91 522.908L746.38 524.878L745.85 522.908L743.88 522.378L745.85 521.847L746.38 519.878Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5938 416.691L89.1241 418.661L91.0938 419.191L89.1241 419.722L88.5938 421.691L88.0634 419.722L86.0938 419.191L88.0634 418.661L88.5938 416.691Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M936.763 862.89L937.293 864.859L939.263 865.39L937.293 865.92L936.763 867.89L936.232 865.92L934.263 865.39L936.232 864.859L936.763 862.89Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1481.22 806.181L1481.75 808.151L1483.72 808.681L1481.75 809.212L1481.22 811.181L1480.69 809.212L1478.72 808.681L1480.69 808.151L1481.22 806.181Z",
    fill: "#D9D9D9"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.56 1018.23L1145.09 1020.2L1147.06 1020.73L1145.09 1021.26L1144.56 1023.23L1144.03 1021.26L1142.06 1020.73L1144.03 1020.2L1144.56 1018.23Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M110.259 512.953L110.789 514.923L112.759 515.453L110.789 515.984L110.259 517.953L109.729 515.984L107.759 515.453L109.729 514.923L110.259 512.953Z",
    fill: "#808080"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1673.03 803.893L1673.56 805.862L1675.53 806.393L1673.56 806.923L1673.03 808.893L1672.5 806.923L1670.53 806.393L1672.5 805.862L1673.03 803.893Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1236.67 1092.98L1237.2 1094.95L1239.17 1095.48L1237.2 1096.01L1236.67 1097.98L1236.14 1096.01L1234.17 1095.48L1236.14 1094.95L1236.67 1092.98Z",
    fill: "#D9D9D9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1186.57 1052.02L1187.1 1053.99L1189.07 1054.52L1187.1 1055.05L1186.57 1057.02L1186.04 1055.05L1184.07 1054.52L1186.04 1053.99L1186.57 1052.02Z",
    fill: "#D9D9D9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M654.935 103.247L655.465 105.217L657.435 105.747L655.465 106.277L654.935 108.247L654.404 106.277L652.435 105.747L654.404 105.217L654.935 103.247Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1592.49 1078.4L1593.02 1080.37L1594.99 1080.9L1593.02 1081.43L1592.49 1083.4L1591.96 1081.43L1589.99 1080.9L1591.96 1080.37L1592.49 1078.4Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M216.025 691.542L216.555 693.511L218.525 694.042L216.555 694.572L216.025 696.542L215.495 694.572L213.525 694.042L215.495 693.511L216.025 691.542Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M867.914 1081.71L868.444 1083.68L870.414 1084.21L868.444 1084.74L867.914 1086.71L867.383 1084.74L865.414 1084.21L867.383 1083.68L867.914 1081.71Z",
    fill: "#D9D9D9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M366.786 559.877L367.316 561.847L369.286 562.377L367.316 562.908L366.786 564.877L366.255 562.908L364.286 562.377L366.255 561.847L366.786 559.877Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M483.043 111.26L483.574 113.23L485.543 113.76L483.574 114.291L483.043 116.26L482.513 114.291L480.543 113.76L482.513 113.23L483.043 111.26Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M480.167 181.558L480.697 183.528L482.667 184.058L480.697 184.588L480.167 186.558L479.636 184.588L477.667 184.058L479.636 183.528L480.167 181.558Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M510.94 124.692L511.47 126.662L513.44 127.192L511.47 127.723L510.94 129.692L510.409 127.723L508.44 127.192L510.409 126.662L510.94 124.692Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M648.882 807.67L649.413 809.64L651.382 810.17L649.413 810.7L648.882 812.67L648.352 810.7L646.382 810.17L648.352 809.64L648.882 807.67Z",
    fill: "#808080"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M669.568 498.13L670.098 500.1L672.068 500.63L670.098 501.16L669.568 503.13L669.038 501.16L667.068 500.63L669.038 500.1L669.568 498.13Z",
    fill: "#D9D9D9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1517.29 849.857L1517.82 851.827L1519.79 852.357L1517.82 852.888L1517.29 854.857L1516.76 852.888L1514.79 852.357L1516.76 851.827L1517.29 849.857Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1068.98 142.777L1069.51 144.747L1071.48 145.277L1069.51 145.808L1068.98 147.777L1068.45 145.808L1066.48 145.277L1068.45 144.747L1068.98 142.777Z",
    fill: "#D9D9D9"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M297.663 908.387L298.193 910.357L300.163 910.887L298.193 911.418L297.663 913.387L297.133 911.418L295.163 910.887L297.133 910.357L297.663 908.387Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M197.136 1096.15L197.666 1098.12L199.636 1098.65L197.666 1099.18L197.136 1101.15L196.605 1099.18L194.636 1098.65L196.605 1098.12L197.136 1096.15Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.56 1034.05L1240.09 1036.02L1242.06 1036.55L1240.09 1037.08L1239.56 1039.05L1239.03 1037.08L1237.06 1036.55L1239.03 1036.02L1239.56 1034.05Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1340.16 569.443L1340.69 571.413L1342.66 571.943L1340.69 572.473L1340.16 574.443L1339.63 572.473L1337.66 571.943L1339.63 571.413L1340.16 569.443Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M373.799 1078.51L374.33 1080.48L376.299 1081.01L374.33 1081.55L373.799 1083.51L373.269 1081.55L371.299 1081.01L373.269 1080.48L373.799 1078.51Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5703 711.586L39.1006 713.556L41.0703 714.086L39.1006 714.617L38.5703 716.586L38.04 714.617L36.0703 714.086L38.04 713.556L38.5703 711.586Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7935 548.613L23.3238 550.583L25.2935 551.113L23.3238 551.644L22.7935 553.613L22.2631 551.644L20.2935 551.113L22.2631 550.583L22.7935 548.613Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M797.734 353.955L798.265 355.924L800.234 356.455L798.265 356.985L797.734 358.955L797.204 356.985L795.234 356.455L797.204 355.924L797.734 353.955Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1614.01 937.165L1614.54 939.135L1616.51 939.665L1614.54 940.196L1614.01 942.165L1613.48 940.196L1611.51 939.665L1613.48 939.135L1614.01 937.165Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1068.44 62.2073L1068.97 64.1769L1070.94 64.7073L1068.97 65.2376L1068.44 67.2073L1067.91 65.2376L1065.94 64.7073L1067.91 64.1769L1068.44 62.2073Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1325.19 738.787L1325.72 740.757L1327.69 741.287L1325.72 741.817L1325.19 743.787L1324.66 741.817L1322.69 741.287L1324.66 740.757L1325.19 738.787Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M116.244 29.3855L116.774 31.3552L118.744 31.8855L116.774 32.4158L116.244 34.3855L115.714 32.4158L113.744 31.8855L115.714 31.3552L116.244 29.3855Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1341.67 128.86L1342.2 130.83L1344.17 131.36L1342.2 131.89L1341.67 133.86L1341.14 131.89L1339.17 131.36L1341.14 130.83L1341.67 128.86Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1614.38 576.426L1614.91 578.396L1616.88 578.926L1614.91 579.456L1614.38 581.426L1613.85 579.456L1611.88 578.926L1613.85 578.396L1614.38 576.426Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1564.06 1018.38L1564.6 1020.35L1566.56 1020.88L1564.6 1021.41L1564.06 1023.38L1563.53 1021.41L1561.56 1020.88L1563.53 1020.35L1564.06 1018.38Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.29 880.772L1018.82 882.742L1020.79 883.272L1018.82 883.802L1018.29 885.772L1017.76 883.802L1015.79 883.272L1017.76 882.742L1018.29 880.772Z",
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_93_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M866.227 135.661C1065.36 144.959 1178.43 267.989 1303.27 361.822C1408.64 441.028 1498.93 523.977 1517.05 624.856C1537.66 739.637 1556.51 877.708 1409.18 951.634C1264.66 1024.14 1054.17 956.674 866.227 951.402C694.222 946.577 505.458 987.744 371.634 922.529C230.298 853.654 199.024 734.294 196.136 624.856C193.192 513.313 237.762 403.652 355.668 317.574C486.452 222.097 661.245 126.089 866.227 135.661Z",
    fill: "url(#paint0_radial_93_2)",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_93_2",
    x: 96,
    y: 35,
    width: 1535,
    height: 1050,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_93_2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_93_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(863.5 560) rotate(90) scale(425 667.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43156E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43156E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient);
export default __webpack_public_path__ + "static/media/gradient.1e6a049e923a5c4efe00b0bba5989dbf.svg";
export { ForwardRef as ReactComponent };